import { Button } from "antd";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import AddAdvancePayment from "./AddAdvancePayment";
import { loadAdvancePaymentsByReporting } from "../../redux/rtk/features/advancePayment/advancePaymentSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import "./AdvancePayment.css";

const AdvancePaymentApprovals = () => {
	const dispatch = useDispatch();
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const employeeId = getUserFromToken();

	useEffect(() => {
		if (isLogged && employeeId) {
			dispatch(loadAdvancePaymentsByReporting(employeeId));
		}
	}, [dispatch, isLogged, employeeId]);

	if (!isLogged) {
		return <Navigate to="/admin/auth/login" replace />;
	}

	return (
		<div className="advance-payment-page-container">
			<div className="flex justify-between items-center mb-4">
				<h2 className="advance-payment-page-title">Advance Payment Approvals</h2>
				<Button
					type="default"
					onClick={() => dispatch(loadAdvancePaymentsByReporting(employeeId))}
				>
					Refresh
				</Button>
			</div>

			<AddAdvancePayment
				tableOnly
				listSource="reporting"
				employeeId={employeeId}
				showApprovalActions
			/>
		</div>
	);
};

export default AdvancePaymentApprovals;
